var manualSync =
webpackJsonp_name_([5],{

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(555);

__webpack_require__(429);

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ManualSyncService = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Listens to uScope events and sets up the ability for the user to enable/activate this extension.
 */
var ManualSyncService = exports.ManualSyncService = function () {
    /**
     * Constructor.
     * @param events
     * @param monitor (Object) An instance of the state monitor.
     * @param synchronizer
     * @param timer (Object) An instance of the sync timer.
     */
    function ManualSyncService(events, monitor, synchronizer, timer) {
        (0, _classCallCheck3.default)(this, ManualSyncService);

        this._monitor = monitor;
        this._synchronizer = synchronizer;
        this._timer = timer;

        // Flag to handle the case when the unpinned image is closed. The VIL closes two images; the requested image and
        // one of the pinned ones, chosen at random, which becomes the new unpinned image when it's restored. Since this
        // is a somewhat unpredictable event we save the state of all viewports before they're closed, then wait for the
        // extra closed one to be reopend and restore all viewport states.
        this._isSuspended = false;

        // Create private "_isActive" property that triggers an event on change.
        createTriggerableState('Active', events, this);

        // Create private "_isEnabled" property that triggers an event on change.
        createTriggerableState('Enabled', events, this);
    }

    /**
     * As one might expect, this method initializes the Sync instance, listening to the uScope instance for viewport
     * open, close, and selected events.
     * @param uScope (Object) The UScope instance that initializes and destroys viewports.
     */


    (0, _createClass3.default)(ManualSyncService, [{
        key: 'init',
        value: function init(uScope) {
            // Listen for changes to uScope state.
            uScope.events.on('uscope:image:init', this._handleViewportAdded, this);
            uScope.events.on('uscope:image:close', this._handleViewportRemoved, this);
            uScope.events.on('uscope:viewport:selected', this._handleSelectedViewportChange, this);
            uScope.events.on('uscope:image:replace', this._handleImageReplace, this);

            // To handle the case when closing the sole "unpinned" image; the VIL closes two images and restores one of them
            uScope.events.on('uscope:viewport:toolbar:close-click', this._handleBeforeViewportRemoved, this);

            // Sync state with uScope and update status.
            this._refresh();
        }

        /**
         * Toggle manual sync active state.
         */

    }, {
        key: 'toggle',
        value: function toggle() {
            if (this._isActive) {
                this.deactivate();
            } else {
                this.activate();
            }
        }

        /**
         * Enables the service, if possible.
         */

    }, {
        key: 'enable',
        value: function enable() {
            if (this._synchronizer.canSync) {
                this._isEnabled = true;
            }
        }

        /**
         * Disables the service. Deactivates if active.
         */

    }, {
        key: 'disable',
        value: function disable() {
            this.deactivate();
            this._isEnabled = false;
        }

        /**
         * Activates the service if possible, causing events to propagate between active viewports.
         */

    }, {
        key: 'activate',
        value: function activate() {
            if (this._isEnabled) {
                this._isActive = true;
                this._monitor.start();
                this._synchronizer.start();
                this._timer.start();
            }
        }

        /**
         * Deactivates the service. Changes will no longer propagate between viewports.
         */

    }, {
        key: 'deactivate',
        value: function deactivate() {
            this._isActive = false;
            this._monitor.stop();
            this._synchronizer.stop();
            this._timer.stop();
        }

        /**
         * Suspends the service and saves the state of all viewports. Changes will no longer propagate between viewports.
         * When unsuspended this state will be restored.
         * Used when closing the unpinned viewport. See description @ _isSuspended declaration.
         */

    }, {
        key: 'suspend',
        value: function suspend() {
            this._isSuspended = true;
            this._timer.stop();
            this._monitor.stop();
            this._synchronizer.saveState();
        }

        /**
         * Restores the state of any viewports that were in view when suspended and restarts the sync service.
         * Used when closing the unpinned viewport. See description @ _isSuspended declaration.
         */

    }, {
        key: 'unsuspend',
        value: function unsuspend() {
            this._synchronizer.restoreState();
            this._monitor.start();
            this._timer.start();
            this._isSuspended = false;
        }

        /**
         * Causes the "enabled" status of the service to update if needed.
         * @private
         */

    }, {
        key: '_updateStatus',
        value: function _updateStatus() {
            if (this._synchronizer.canSync) {
                this.enable();
            } else {
                this.disable();
            }
        }

        /**
         * Sync's the monitor and synchronizer to uScope and updates the enabled state if needed.
         * @private
         */

    }, {
        key: '_refresh',
        value: function _refresh() {
            this._monitor.refresh();
            this._synchronizer.refresh();
            this._updateStatus();
        }

        /**
         * Replacing an image occurs when a user selects another image from the slide tray. This will swap out the unpinned
         * image for a different one. Since the new one's dimensions are not known, we treat it same as opening a new image
         * and suspend the service.
         * @private
         */

    }, {
        key: '_handleImageReplace',
        value: function _handleImageReplace() {
            // Image replacement also occurs when switching the unpinned image; one of the previously-pinned images
            // takes the place of the unpinned image. In this instance the user has already syncd the image's position
            // and we don't need to suspend.
            if (this._isSuspended) {
                return;
            }

            this.deactivate();
        }

        /**
         * Selected VP change event handler.
         * @private
         */

    }, {
        key: '_handleSelectedViewportChange',
        value: function _handleSelectedViewportChange() {
            this._refresh();

            // Switching viewports causes the monitor to stop listening for change events. Restart it.
            if (this._isActive) {
                this._monitor.start();
            }
        }

        /**
         * Viewport added event handler.
         * @private
         */

    }, {
        key: '_handleViewportAdded',
        value: function _handleViewportAdded(viewport) {
            this._refresh();

            if (this._isSuspended) {
                // Wait for the viewport to load image data and situate itself, then unsuspend the service.
                viewport.events.once('viewport:image-opened', this.unsuspend, this);
            } else {
                // When an additional image is added, system shall unsync all opened images and automatically toggle the
                // sync button to 'off'.
                this.deactivate();
            }
        }

        /**
         * Here to handle the case when the unpinned image is closed.
         * @param viewport
         * @private
         */

    }, {
        key: '_handleBeforeViewportRemoved',
        value: function _handleBeforeViewportRemoved(viewport) {
            if (!viewport.isPinned()) {
                this.suspend();
            }
        }

        /**
         * Viewport removed event handler.
         * @private
         */

    }, {
        key: '_handleViewportRemoved',
        value: function _handleViewportRemoved() {
            if (this._isSuspended) {
                return;
            }

            // Switching viewports causes the monitor to stop listening for change events. Restart it.
            if (this._isActive) {
                this._monitor.start();
            }
        }
    }]);
    return ManualSyncService;
}();

/**
 * This function creates a private getter and setter on the given context object. Changes are published on the event channel.
 * @param name (String) The name of the value to track. This value will be the basis of the event that gets published and will be prefixed with "_is" when attached to context.
 * @param events (EventChannel) The event channel to publish change events on. Format is "manual-sync:{name}-{on || off}.
 * @param context (Object) The object to attach the property to.
 */


function createTriggerableState(name, events, context) {
    // Define a backing property. Setting the initial value to "null" guarantees that initialization will cause an event
    // to be published, so we don't need to artificially do external initialization (like make button initially disabled)
    var state = null;

    // Define the property.
    Object.defineProperty(context, '_is' + name, {
        // Simple getter.
        get: function get() {
            return state;
        },


        // Setter with change detection and event publishing.
        set: function set(value) {
            if (value !== state) {
                state = value;
                var event = 'manual-sync:' + name.toLowerCase() + '-' + (state ? 'on' : 'off');
                events.trigger(event);
            }
        }
    });
}

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Timer = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INVALID_TIMER_ID = Math.MIN_SAFE_INTEGER;

/**
 * Responsible for managing the render cycle that allows changes to the active viewport state to propagate to tracked viewports.
 */

var Timer = exports.Timer = function () {
    function Timer(monitor, synchronizer) {
        (0, _classCallCheck3.default)(this, Timer);

        this._monitor = monitor;
        this._synchronizer = synchronizer;
        this._timerId = INVALID_TIMER_ID;
    }

    /**
     * Commands the timer instance to start monitoring the selected viewport and sync the others.
     */


    (0, _createClass3.default)(Timer, [{
        key: "start",
        value: function start() {
            if (this._timerId === INVALID_TIMER_ID) {
                this._run();
            }
        }

        /**
         * Helper method to enable the timer's loop. Not meant to be called externally.
         * @private
         */

    }, {
        key: "_run",
        value: function _run() {
            var _this = this;

            this._timerId = window.requestAnimationFrame(function () {
                if (_this._monitor.hasChanged) {
                    _this._synchronizer.sync(_this._monitor.deltaState);
                    _this._monitor.clearChanges();
                }
                _this._run();
            });
        }

        /**
         * Cancels the timer loop if running.
         */

    }, {
        key: "stop",
        value: function stop() {
            if (this._timerId !== INVALID_TIMER_ID) {
                window.cancelAnimationFrame(this._timerId);
                this._timerId = INVALID_TIMER_ID;
            }
        }
    }]);
    return Timer;
}();

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackerFactory = exports.ViewTracker = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper for logic to synchronize one viewport with another.
 */
var ViewTracker = exports.ViewTracker = function () {
    function ViewTracker(viewport) {
        (0, _classCallCheck3.default)(this, ViewTracker);

        this.viewport = viewport;
        this._vpState = viewport.getVPView();
        this._vpNormalizationFactor = viewport.getNormalizationFactor();
        this._isSelected = false;
        this._isStarted = false; // To track the manual sync on/off status
    }

    (0, _createClass3.default)(ViewTracker, [{
        key: "start",


        /**
         * Creates reference "initial state" properties to track changes to the viewport's state.
         */
        value: function start() {
            this._isStarted = true;
            this._updateVpReadOnlyMode();

            var initialState = Object.assign({}, this._vpState);
            this._requestedZoom = initialState.zoom;
            this._requestedPan = {
                left: initialState.left,
                top: initialState.top
            };
            // Because rotation is unbounded there's no need to track its position relative to its initial state.
        }
    }, {
        key: "stop",
        value: function stop() {
            this._isStarted = false;
            this._updateVpReadOnlyMode();

            delete this._requestedZoom;
            delete this._requestedPan;
        }

        /**
         * Update tracker VP readonly param to false so that other plugin should not overlap
         */

    }, {
        key: "_updateVpReadOnlyMode",
        value: function _updateVpReadOnlyMode() {
            // To ensure other plugins are enabled on adding VP where manual sync is disable
            // To ensure other plugins are disabled only for tracked VP when manual sync ON
            // To ensure other plugins are re-enabled for tracked VP when manual sync OFF
            this.viewport.setReadOnlyMode(!this.isSelected && this._isStarted);
        }

        /**
         * Updates the tracking properties and, if required, updates the viewport itself.
         * @param deltaState
         */

    }, {
        key: "updateState",
        value: function updateState(deltaState) {
            var viewport = this.viewport;

            // Note the "else" statements. The reason for these is that zoom and rotate affect the bounds of the viewport, making
            // it appear as if it has panned when really it hasn't. If we allowed fallthrough zoom and rotate operations
            // behave weirdly. The "else" fixes this, but has the potential to introduce errors if the user actually zooms
            // then pans between repaints. At 30 fps this is unlikely but if needed we can probably fix by keeping a more
            // accurate delta in the state monitor.

            // Zoom only if needed.
            if (deltaState.zoomRatio !== 1 && Number.isFinite(deltaState.zoomRatio)) {
                this._updateRequestedZoom(deltaState.zoomRatio);
                // Zooming alters the coordinate system, so also sync the x,y coordinates.
                this._updateRequestedPan(deltaState.left, deltaState.top, this._vpNormalizationFactor);

                this._zoomTheViewport();
            }

            // Rotate only if needed.
            else if (!this.isSelected && deltaState.angleDeg) {
                    viewport.viewRotate(this._vpState.angleDeg + deltaState.angleDeg);
                }

                // Pan only if needed.
                else if (deltaState.left || deltaState.top) {
                        this._updateRequestedPan(deltaState.left, deltaState.top, this._vpNormalizationFactor);
                        this._moveTheViewport();
                    }
        }

        /**
         * Solely here to handle the case when the unpinned image is closed. Exposes the tracker's initial state
         * so that it can be restored. See the description for _isClosingUnpinnedImage in ManualSyncService for more info.
         * @returns {{zoom: *, pan: *}}
         */

    }, {
        key: "getState",
        value: function getState() {
            var _vpState = this._vpState,
                top = _vpState.top,
                left = _vpState.left,
                angleDeg = _vpState.angleDeg,
                zoom = _vpState.zoom;

            return {
                trackerState: {
                    zoom: this._requestedZoom,
                    pan: this._requestedPan
                },
                viewportState: { top: top, left: left, angleDeg: angleDeg, zoom: zoom }
            };
        }

        /**
         * Solely here to handle the case when the unpinned image is closed. Restores the tracker's initial state.
         * See the description for _isClosingUnpinnedImage in ManualSyncService for more info.
         * @param trackerState
         * @param viewportState
         */

    }, {
        key: "setState",
        value: function setState(_ref) {
            var trackerState = _ref.trackerState,
                viewportState = _ref.viewportState;

            this._requestedZoom = trackerState.zoom;
            this._requestedPan = trackerState.pan;

            this.viewport.zoomAbsolute(viewportState.zoom);
            this.viewport.moveAbsolute(viewportState.left, viewportState.top);
            this.viewport.viewRotate(viewportState.angleDeg);
        }

        /**
         * Updates requested zoom level.
         * @param deltaZoom - the amount to change zoom.
         * @private
         */

    }, {
        key: "_updateRequestedZoom",
        value: function _updateRequestedZoom(deltaZoom) {
            this._requestedZoom *= deltaZoom; // update the tracked VP w.r.t selected VP ratio
        }

        /**
         * Update's the viewport's zoom to the requested zoom level.
         * @private
         */

    }, {
        key: "_zoomTheViewport",
        value: function _zoomTheViewport() {
            if (this.isSelected) {
                return;
            }
            this.viewport.zoomAbsolute(this._requestedZoom);
        }

        /**
         * Updates this._requestedPan by the deltaTop and Left
         * @param deltaLeft amount to pan left
         * @param deltaTop amount to pan top
         * @param normalizationFactor scale the pan operation, if needed.
         * @private
         */

    }, {
        key: "_updateRequestedPan",
        value: function _updateRequestedPan(deltaLeft, deltaTop, normalizationFactor) {
            this._requestedPan = {
                left: (this._requestedPan.left + deltaLeft) * normalizationFactor,
                top: (this._requestedPan.top + deltaTop) * normalizationFactor
            };
        }

        /**
         * Commands the viewport to pan the viewport by this._requestedPan.
         * @private
         */

    }, {
        key: "_moveTheViewport",
        value: function _moveTheViewport() {
            if (this.isSelected) {
                return;
            }
            this.viewport.moveAbsolute(this._requestedPan.left, this._requestedPan.top);
        }
    }, {
        key: "isSelected",
        get: function get() {
            return this._isSelected;
        },
        set: function set(value) {
            if (this._isSelected !== value) {
                this._isSelected = value;
                this._updateVpReadOnlyMode();
            }
        }
    }]);
    return ViewTracker;
}();

var trackerFactory = exports.trackerFactory = {
    create: function create(viewer) {
        return new ViewTracker(viewer);
    }
};

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ViewportStateMonitor = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Encapsulates logic to sync a viewport.
 */
var ViewportStateMonitor = exports.ViewportStateMonitor = function () {
    function ViewportStateMonitor(uScope) {
        (0, _classCallCheck3.default)(this, ViewportStateMonitor);

        this._uScope = uScope;

        // The last tracked state.
        this.lastState = null;

        // The current state.
        this.currentState = null;

        // Whether or not the state has changed. Use getter so we don't need to manually update.
        Object.defineProperty(this, 'hasChanged', {
            get: function get() {
                return this.lastState !== this.currentState;
            }
        });

        // Provide a getter that computes the change in state, normalized as needed.
        Object.defineProperty(this, 'deltaState', {
            get: function get() {
                var a = this.lastState;
                var b = this.currentState;
                var n = this._viewport.getNormalizationFactor();

                return {
                    top: (b.top - a.top) / n,
                    left: (b.left - a.left) / n,
                    height: (b.height - a.height) / n,
                    width: (b.width - a.width) / n,
                    zoomRatio: b.zoom / a.zoom,
                    angleDeg: b.angleDeg - a.angleDeg
                };
            }
        });
    }

    /**
     * Updates the tracked viewport from uScope. NOTE: Stops listening to events on the original viewport.
     */


    (0, _createClass3.default)(ViewportStateMonitor, [{
        key: 'refresh',
        value: function refresh() {
            this.stop();
            this._viewport = this._uScope.getThisImage();
        }

        /**
         * Start watching the selected viewport.
         */

    }, {
        key: 'start',
        value: function start() {
            // Start listening to the viewport.
            this._listeners = [this._viewport.events.on('viewport:state-changed', this._update, this)];

            // Capture the current state.
            this._update();

            // Sync last state to current state.
            this.clearChanges();
        }

        /**
         * Updates the current viewport state.
         */

    }, {
        key: '_update',
        value: function _update() {
            this.currentState = Object.assign({}, this._viewport.getVPView());
        }

        /**
         * Sets last state to current state, clearing any indication of state change.
         */

    }, {
        key: 'clearChanges',
        value: function clearChanges() {
            this.lastState = this.currentState;
        }

        /**
         * Stops observing viewport state changes and clears all state info.
         */

    }, {
        key: 'stop',
        value: function stop() {
            if (this._listeners) {
                this._listeners.forEach(function (detatch) {
                    detatch();
                });
                delete this._listeners;
            }

            this.lastState = null;
            this.currentState = null;
        }
    }]);
    return ViewportStateMonitor;
}();

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ViewportSyncronizer = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A wrapper class managing the syncing of multiple viewports.
 */
var ViewportSyncronizer = exports.ViewportSyncronizer = function () {
    function ViewportSyncronizer(uScope, trackerFactory) {
        (0, _classCallCheck3.default)(this, ViewportSyncronizer);

        this._uScope = uScope;
        this._factory = trackerFactory;
        this._trackers = [];
        this._savedStates = {};
    }

    /**
     * Refreshes the list of viewports and indicates which one is currently selected.
     */


    (0, _createClass3.default)(ViewportSyncronizer, [{
        key: 'refresh',
        value: function refresh() {
            var _this = this;

            var selectedViewport = this._uScope.getThisImage();
            var allViewports = this._uScope.getAllImages();

            // allViewports is sometimes undefined.
            // Possibly it is called 2 times _handleSelectedViewportChange and/or _handleViewportAdded?
            if (!allViewports) {
                throw new Error('there are no viewports - why are we here?');
            }

            // Add any missing viewports. Update selected flag while we're in here.
            allViewports.forEach(function (viewport) {
                if (viewport === undefined) {
                    return;
                }

                var tracker = _this._findOrCreateTracker(viewport);

                tracker.isSelected = viewport === selectedViewport;
            });

            // Remove viewports that are no longer open.
            this._removeOrphanedTrackers(allViewports);
        }
    }, {
        key: '_findOrCreateTracker',
        value: function _findOrCreateTracker(viewport) {
            // Look for the viewport in the list of trackers and return it if we find it.
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this._trackers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var tracker = _step.value;

                    if (tracker.viewport === viewport) {
                        return tracker;
                    }
                }

                // If it's not found, create it.
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return this._createViewportTracker(viewport);
        }
    }, {
        key: '_createViewportTracker',
        value: function _createViewportTracker(viewport) {
            var tracker = this._factory.create(viewport);
            this._trackers.push(tracker);
            return tracker;
        }
    }, {
        key: '_removeOrphanedTrackers',
        value: function _removeOrphanedTrackers(allViewports) {
            if (this._trackers.length === 0) {
                return;
            }

            this._trackers = this._trackers.filter(function (tracker) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = allViewports[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var viewport = _step2.value;

                        if (viewport && tracker.viewport === viewport) {
                            return true;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return false;
            });
        }

        /**
         * Instructs each viewport tracker to begin tracking.
         */

    }, {
        key: 'start',
        value: function start() {
            this._trackers.forEach(function (vp) {
                return vp.start();
            });
        }

        /**
         * Instructs each viewport tracker to end tracking.
         */

    }, {
        key: 'stop',
        value: function stop() {
            this._trackers.forEach(function (vp) {
                return vp.stop();
            });
        }

        /**
         * Instructs each tracker to synchronize its viewport with the indicated state changes.
         * @param deltaState
         */

    }, {
        key: 'sync',
        value: function sync(deltaState) {
            // note: switched to "forEach" rather than "for ...of" because the babel translation makes it harder to debug
            this._trackers.forEach(function (tracker) {
                tracker.updateState(deltaState);
            });
        }

        /**
         * Indicates whether or not we can synchronize.
         * @returns {boolean}
         */

    }, {
        key: 'saveState',


        /**
         * Solely here to handle the case when the unpinned image is closed. Exposes the tracker's initial state
         * so that it can be restored. See the description for _isClosingUnpinnedImage in ManualSyncService for more info.
         */
        value: function saveState() {
            var _this2 = this;

            this._trackers.forEach(function (tracker) {
                var imageId = tracker.viewport.getImageId();
                _this2._savedStates[imageId] = tracker.getState();
            });
        }

        /**
         * Solely here to handle the case when the unpinned image is closed. Restores the tracker's initial state.
         * See the description for _isClosingUnpinnedImage in ManualSyncService for more info.
         */

    }, {
        key: 'restoreState',
        value: function restoreState() {
            var _this3 = this;

            this._trackers.forEach(function (tracker) {
                var imageId = tracker.viewport.getImageId();
                var state = _this3._savedStates[imageId];
                tracker.setState(state);
            });
            this._savedStates = {};
        }
    }, {
        key: 'canSync',
        get: function get() {
            return this._trackers.length > 1;
        }
    }]);
    return ViewportSyncronizer;
}();

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

var _Timer = __webpack_require__(425);

var _ViewportStateMonitor = __webpack_require__(427);

var _ViewTracker = __webpack_require__(426);

var _ViewportSyncronizer = __webpack_require__(428);

var _ManualSyncService = __webpack_require__(424);

var _toolbarButtonHelper = __webpack_require__(430);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_publicApi2.default.plugins.register({
    name: 'us:manual-sync',

    extends: 'uScope',

    constructor: function constructor(uScope) {
        var eventChannel = uScope.events.$new();
        var monitor = new _ViewportStateMonitor.ViewportStateMonitor(uScope);
        var synchronizer = new _ViewportSyncronizer.ViewportSyncronizer(uScope, _ViewTracker.trackerFactory);
        var timer = new _Timer.Timer(monitor, synchronizer);
        var service = new _ManualSyncService.ManualSyncService(eventChannel, monitor, synchronizer, timer);
        var button = (0, _toolbarButtonHelper.createButton)(eventChannel, function () {
            service.toggle();
        });

        // Start the sync service.
        service.init(uScope);

        uScope.topToolbar.addButton(button);
    }
});

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createButton = createButton;

var _toolbarButtonFactory = __webpack_require__(79);

var DEFAULT_BUTTON_CLASS = 'uscope-manual-sync-button';
var ACTIVE_BUTTON_CLASS = 'uscope-manual-sync-active';
var BUTTON_HOVER_TEXT = 'Manually sync the image\'s displayed XY coordinates, magnification levels and rotation together';

function createButton(eventChannel, onClick) {
    var button = (0, _toolbarButtonFactory.createToolbarButton)({
        className: DEFAULT_BUTTON_CLASS,

        title: BUTTON_HOVER_TEXT,

        onClick: onClick
    });

    var enableButton = function enableButton() {
        button.disabled = false;
    };
    var disableButton = function disableButton() {
        button.disabled = true;
    };

    var activateButton = function activateButton() {
        button.classList.add(ACTIVE_BUTTON_CLASS);
    };
    var deactivateButton = function deactivateButton() {
        button.classList.remove(ACTIVE_BUTTON_CLASS);
    };

    eventChannel.on('manual-sync:enabled-on', enableButton);
    eventChannel.on('manual-sync:enabled-off', disableButton);
    eventChannel.on('manual-sync:active-on', activateButton);
    eventChannel.on('manual-sync:active-off', deactivateButton);

    return button;
}

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(338);


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * As the name suggests, creates a <button> object that can be added to uScope's toolbar.
 * When styling using this method, you should set the background image manually using CSS.
 * NOTE The styling should include ".us_rootstyle" to ensure eSM rules don't override
 *      styling on hover.
 * @param className (string) - name of class to attach to button. Useful for attaching images
 * @param title (string) - alt-text that will appear when user hovers over the icon
 * @param onClick (function) - callback to execute when the user clicks the button
 */
var createToolbarButton = exports.createToolbarButton = function createToolbarButton(_ref) {
    var className = _ref.className,
        title = _ref.title,
        onClick = _ref.onClick,
        _ref$context = _ref.context,
        context = _ref$context === undefined ? null : _ref$context;

    var button = document.createElement('button');
    button.className = 'uscope-toolbar-button ' + className;
    button.title = title;

    button.addEventListener('click', function (e) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        onClick.apply(context, [e].concat(args));
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    });

    return button;
};

/***/ })

},[622]);